import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../layouts/AuthContext';
import { Loading } from '../../components/common/Loading';

interface RouteGuardProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  redirectTo?: string;
}

export const RouteGuard = ({
  children,
  requireAuth = false,
  redirectTo = '/login',
}: RouteGuardProps): JSX.Element => {
  const { isAuthenticated, isCheckingAuth } = useAuth();
  const location = useLocation();

  // Trường hợp đặc biệt: nếu đang ở trang yêu cầu auth (requireAuth=true) và đang check auth,
  // hiển thị loading trước để tránh flash của màn login
  if (isCheckingAuth) {
    return <Loading />;
  }

  // Cho các protected routes: chỉ chuyển hướng về login nếu KHÔNG authenticated và KHÔNG đang check auth
  if (requireAuth && !isAuthenticated && !isCheckingAuth) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Chỉ chuyển hướng từ trang login về assets nếu đã authenticated và không đang check auth
  if (!requireAuth && isAuthenticated && location.pathname === '/login' && !isCheckingAuth) {
    return <Navigate to="/assets" replace />;
  }

  // Return children wrapped in a fragment to ensure JSX.Element
  return <>{children}</>;
};
